import { setRoute } from '../../routes/actions/set';
import { Amount } from 'src_common/common/amount/Amount';

function mapData(data) {
    if (data === undefined) {
        return;
    }

    if (data === null) {
        return null;
    }

    const elementsToTransform = [
        'potentialReturns',
        'stakePerLine',
        'totalStake',
        'maxBet',
        'minPotentialReturns',
        'operatorPayout',
        'operatorStakePerLine',
        'operatorTotalStake',
        'payout',
        'liabilityLimit',
        'maxBet',
        'maxMultipleBet',
        'maxWin'

    ];

    for (const element of elementsToTransform) {
        const value = data[element];
        if (value !== undefined && (typeof value === 'string' || typeof value === 'number')) {
            data[element] = $appState.configState.precision.newFromAnything(value).value;
        } else if (value !== undefined) {
            console.warn('Wrong data format in audit map data to Amount: value is', value);
        }
    }

    return data;
}


export function request(id, data, filterName) {
    return (dispatch, getState) => {
        dispatch({
            type: 'AUDITS_QUERY_REQUEST',
            data,
            id
        });
        if (data && data.allAudits == true) {
            const params = { allAudits: true };
            $appState.router.onChange('customers:' + id, params);
        } else {
            const filter = filterName ? filterName : data.filterName;
            const params = { auditFilter: filter };
            $appState.router.onChange('customers:' + id, params);
        }

        dispatch(setRoute('audits:' + id, {}));
    };
}

export function error(id, errors) {
    return {
        type: 'AUDITS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, query, audits) {

    audits.results = audits.results.map(res => {
        if (res?.body?.bet !== undefined) {
            res.body.bet = mapData(res.body.bet);
        }

        if (res?.body?.betLimits) {
            res.body.betLimits = mapData(res.body.betLimits);
        }

        return res;
    });

    return (dispatch) => {
        dispatch({
            type: 'AUDITS_QUERY_FINISH',
            audits,
            query,
            id
        });
    };
}
